export default __webpack_public_path__ + "static/media/onboarding-step-4.27abaec3.png";